<template>
    <div v-if="company" class="animated fadeIn">
      <FinanceResult :company="company" :report="report"/>
      <div v-if="!report.report_data">
        <b-row>
          <b-col sm="6" class="mx-auto">
              <b-card>
            <div slot="header">
              <strong>Диагностика компании </strong>&laquo;<small>{{company.name}}&raquo;(ОГРН {{company.ogrn}})</small> <directory slug="etap-diagnostiki-ekspress-fin" />
            </div>
            <form @submit.prevent="saveConfirm({rawData: rawData, isSend: true})">
              <b-form-group>
                <h5>Средняя ставка по депозиту ЦБ РФ за последний месяц по договорам с физическими лицами в российских рублях (в процентах) на срок свыше 1 года:</h5>
                <b-form-input placeholder="Введите среднюю ставку" :required="true" v-model="rawData.avg" />
              </b-form-group>
              <p class="form-text text-dark">
                Нажмите на данную ссылку, чтобы перейти на сайт Центрального банка РФ  - <a target="_blank" href="http://cbr.ru/analytics/ibudv/budv/">http://cbr.ru/analytics/ibudv/budv/</a>
                <br/>
                Выберите из предложенных месяцев наиболее актуальный. В открывшемся файле выберите ставку по договорам с физическими лицами в российских рублях (в процентах) на срок свыше 1 года. Введите процентную ставку в поле выше.
              </p>
              <b-form-group>
                <h5>Выбор типа налогообложения проверяемой компании:</h5>
                <b-form-radio-group id="basicRadios"
                                    :plain="true"
                                    :required="true"
                                    v-model="rawData.type"
                                    :options="[
                                {text: 'ОСН ', value: 'osn'},
                                {text: 'УСН ',value: 'usn'}
                              ]"
                                    checked="usn">
                </b-form-radio-group>
                <br/>
                <div class="pull-left">
                  <router-link :to="'/diagnost/' + id" class="btn btn-sm btn-outline">
                    <i class="fa fa-arrow-circle-left"></i>
                    Назад
                  </router-link>
                </div>
                <b-button type="submit" variant="success" class="pull-right">
                  <i class="fa fa-dot-circle-o"></i>
                  Провести проверку
                </b-button>
              </b-form-group>
            </form>
          </b-card>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row>
          <b-col>
            <b-card>
              <div slot="header">
                <ul class="list-group pull-right">
                  <li class="list-group-item py-2" :class="'list-group-item-' + report.status">
                    {{ report.status_crm }}
                  </li>
                </ul>
                <strong>Диагностика компании </strong>&laquo;<small>{{company.name}}&raquo;(ОГРН {{company.ogrn}})</small>
              </div>
              <b-table hover :fields="tableFields" :items="report.report_data.params">
                <template :slot="tableFields[1].key" slot-scope="scope">
                  <span v-if="scope.item[tableFields[1].key] === false" class="badge badge-secondary">Нет данных</span>
                  <span v-else>{{scope.item[tableFields[1].key]}}</span>
                </template>
                <template :slot="tableFields[2].key" slot-scope="scope">
                  <span v-if="scope.item[tableFields[2].key] === false" class="badge badge-secondary">Нет данных</span>
                  <span v-else>{{scope.item[tableFields[2].key]}}</span>
                </template>
                <template :slot="tableFields[3].key" slot-scope="scope">
                  <span v-if="scope.item[tableFields[3].key] === false" class="badge badge-secondary">Нет данных</span>
                  <span v-else>{{scope.item[tableFields[3].key]}}</span>
                </template>
                <template slot="points" slot-scope="scope">
                  <span v-if="scope.item.points === false" class="badge badge-danger">Ошибка!</span>
                  <span v-else>{{scope.item.points}}</span>
                </template>
              </b-table>
              <div class="pull-right">
                <h5 v-if="report.report_data.total !== false">Общий балл: {{report.report_data.total}}</h5>
                <h5 v-else>Общий балл: <span class="text-danger">ошибка расчета</span></h5>
              </div>
              <div slot="footer">
                <button @click="print" v-if="report.status !== 'secondary'" type="button" class="btn btn-primary btn-sm text-white pull-right">
                  <i class="fa fa-print"></i>
                  Распечатать
                </button>
                <router-link :to="'/diagnost/' + id" class="btn btn-sm btn-outline">
                  <i class="fa fa-arrow-circle-left"></i>
                  Назад
                </router-link>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
</template>

<script>
    import { eventHub } from '../utils/eventhub'
    import client from '../backend/client';
    import { Switch as cSwitch } from '@coreui/vue';
    import FinanceResult from "./FinanceResult";
    import Directory from "../components/Directory.vue";
    export default {
        name: "DiagnostFinance",
        props: ['companyId'],
        components: {
          Directory,
            FinanceResult,
            cSwitch
        },
        data: () => {
            return {
                company: null,
                accounting: [],
                report: null,
                rawData: {},
                currentYear: new Date().getMonth()+1 >= 6 ? new Date().getFullYear() : new Date().getFullYear() - 1,
                tableFields: [],
            }
        },
        mounted() {

            if(this.company) {
              this.id = this.companyId;
            } else {
              this.id = this.$route.params.id;
            }

            this.tableFields.push({
                    key: 'title',
                    label: 'Название параметра'
            });
            for (let i = 3; i >= 1; i--) {
                this.tableFields.push({
                    key: (this.currentYear - i).toString()
                });
            }
            this.tableFields.push({
                key: 'points',
                label: 'Баллы'
            });
            client
                .get('api/enrolls/' + this.id + '/company')
                .then((res) => {
                    this.company = res.data;
                    this.report = this.company.enroll.reports.finance_express_report;
                })
            ;
        },
        methods: {
            saveConfirm(params) {
                this.$bvModal.msgBoxConfirm('Пожалуйста, убедитесь, что вы ввели верные данные по средней ставке по депозиту ЦБ РФ и выбрали правильный режим налогообложения. После нажатия Ок произойдет автоматический расчет параметров и присвоение статуса компании (Кандидат или Архив).', {
                    title: 'Подтвердите действие:',
                    okVariant: 'danger',
                    okTitle: 'Да',
                    cancelTitle: 'Нет',
                    hideHeaderClose: false,
                    centered: true
                }).then(res => {
                    if(res) {
                        this.updateReport(params);
                    }
                })
            },
            updateReport(params, message = true) {
                return client
                    .put('api/crm/enrollreports/' + this.report.id, params)
                    .then(res => {
                        this.report = res.data;
                        eventHub.$emit('finance_report', this.report.status.indexOf(['success', 'warning', 'secondary']) > -1)
                        if(message) {
                            this.$toasted.show('Изменения сохранены', {type: 'success'});
                        }
                    })
            },
            print() {
                let block = window.open('', 'PRINT');
                block.document.write('<html><head>');
                block.document.write('<style>@page { size: portrait;}</style>');
                block.document.write('</head><body>');
                block.document.write(document.getElementById('print').innerHTML);
                block.document.write('</body></html>');
                block.document.close();
                block.focus();
                block.print();
                block.close();
                return true;
            }
        }
    }
</script>

<style scoped>
  .container  {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .container .row {
    margin: 0 auto;
  }
</style>
